// Actions

import axios from '@/axios.js'

export default {
  GetList1({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `log/mo_report?start_time=${params.start_time}&end_time=${params.end_time}&from=0&count=10&group=user_id%2Cuser_name%2Csms_uuid%2Csms_time%2Ccompany_name%2Cani%2Cdnis%2Csms_content%2Cvendor_id&sort=${params.order_by}&order=${params.order_dir}`,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => reject(err))
    })
  },
  GetList({commit}, params) {
    return new Promise((resolve, reject) => {
      console.log(params,111100000000000000000000000000000000000000000)
      axios({
        url:params.reporting ?`log/report?start_time=${params.start_time}&end_time=${params.end_time}&count=${params.count}&fields=sent%2Cdelivered%2Ctx_cost&from=${params.from}&per_page=${params.per_page}&page=${params.page}&group=country&sort=${params.order_by}&order=desc&step=day`:
          `log/report?start_time=${params.start_time}&end_time=${params.end_time}&count=${params.count}&fields=tx_cost%2Cdelivered%2Csent&from=${params.from}&per_page=${params.per_page}&page=${params.page}&group=sms_uuid%2Csms_time%2Cuser_id%2Cuser_name%2Ccompany_name%2Cani%2Cdnis%2Csms_content%2Croute_status%2Cvendor_id%2Cdelivered%2Crelay_dlr_content&sort=${params.order_by}&order=desc`,

        method: 'GET'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => reject(err))
    })
  },
  GetListForCompanyAdmin({commit}, params) {
    return new Promise((resolve, reject) => {
      console.log(params,1111)
      let url = `log/report?start_time=${params.start_time}&end_time=${params.end_time}&from=${params.from}&count=${params.count}&fields=tx_cost%2Cdelivered%2Csent&group=user_id%2Cuser_name`
      if(params.step){
        url += `&step=${params.step}`
      }
      axios({
        url: url,
        method: 'GET'
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  GetListByFiltered({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `log/report?start_time=${params.start_time}&end_time=${params.end_time}&from=0&count=10&fields=tx_cost%2Cdelivered%2Csent&step=${params.step}`,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => reject(err))
    })
  },
  GetListFilterdValue({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `log/report?start_time=${params.start_time}&end_time=${params.end_time}&count=10&fields=tx_cost%2Cdelivered%2Csent&group=sms_uuid%2Csms_time%2Cuser_id%2Cuser_name%2Ccompany_name%2Cani%2Cdnis%2Csms_content%2Croute_status%2Cvendor_id%2Cdelivered%2Crelay_dlr_content&sort=${params.order_by}&order=desc&ani=${params.ani}&dnis=${params.dnis}&sms_content=${params.sms_content}`,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => reject(err))
    })
  },
  GetListInboundValue({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `log/mo_report?start_time=${params.start_time}&end_time=${params.end_time}&from=${params.from}&count=${params.count}&group=user_id%2Cuser_name%2Csms_uuid%2Csms_time%2Ccompany_name%2Cani%2Cdnis%2Csms_content%2Cvendor_id&sort=${params.order_by}&order=${params.order_dir}&ani=${params.ani}`,
        method: 'GET'
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
}
